module.exports = __webpack_public_path__ + "static/media/XQZN3189.133a520e.JPG";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/make_over/XQZN3189.JPG
// module id = 327
// module chunks = 0